module.exports = __webpack_public_path__ + "img/atinet.c2c1f168.png";